import autobind from "autobind-decorator";
import ResizeObserver from "resize-observer-polyfill";
import { Console } from "./console";

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl"; // 'xxl';
type ResizedCB = (isOver: boolean, currentBreakpoint: Breakpoint) => void;

// Bootstrap 4.6.x breakpointok
export const BS_GRID_BREAKPOINTS: Record<Breakpoint, number> = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	// xxl: 1400, // NOTE: Bootstrap v5
};
const BS_GRID_BREAKPOINTS_LIST = Object.keys(BS_GRID_BREAKPOINTS);

export class ResponsiveHelper {
	private bodyElement: HTMLBodyElement;
	private breakpointIndex: number;
	private myObserver: ResizeObserver;
	private handleViewChangeCallback: ResizedCB;
	private previousBreakpoint = undefined;

	private static getCurrentBreakpoint(): Breakpoint {
		const { innerWidth } = window;

		if (innerWidth < BS_GRID_BREAKPOINTS.sm) {
			return "xs";
		}

		if (innerWidth < BS_GRID_BREAKPOINTS.md) {
			return "sm";
		}

		if (innerWidth < BS_GRID_BREAKPOINTS.lg) {
			return "md";
		}

		if (innerWidth < BS_GRID_BREAKPOINTS.xl) {
			return "lg";
		}

		return "xl";
	}

	/**
	 * @param callback Callback esemény, amit meghívunk ha változik a breakpont állapota
	 * @param breakpoint Váltás mérete
	 */
	public constructor(breakpoint: Breakpoint, callback: ResizedCB) {
		this.handleViewChangeCallback = callback;
		this.breakpointIndex = BS_GRID_BREAKPOINTS_LIST.indexOf(breakpoint);
	}

	public startObserving(): void {
		if (!this.myObserver) {
			this.bodyElement = document.querySelector("body");
			this.myObserver = new ResizeObserver(this.checkBreakpointChange);
			this.myObserver.observe(this.bodyElement);

			this.checkBreakpointChange();
		} else {
			Console.error("This responsive helper instance already has an observer callback.");
		}
	}

	public stopObserving(): void {
		if (this.myObserver) {
			this.myObserver.disconnect();
		}
	}

	public getActualStatus(): boolean {
		const currentBreakpoint = ResponsiveHelper.getCurrentBreakpoint();

		return this.breakpointIndex <= BS_GRID_BREAKPOINTS_LIST.indexOf(currentBreakpoint);
	}

	@autobind
	private checkBreakpointChange(): void {
		const currentBreakpoint = ResponsiveHelper.getCurrentBreakpoint();

		if (this.previousBreakpoint !== currentBreakpoint) {
			this.previousBreakpoint = currentBreakpoint;

			this.handleViewChangeCallback(
				this.breakpointIndex <= BS_GRID_BREAKPOINTS_LIST.indexOf(currentBreakpoint),
				currentBreakpoint,
			);
		}
	}

	public static mediaBreakPointUp(breakpoint: Breakpoint): boolean {
		const currentBreakpointIndex = BS_GRID_BREAKPOINTS_LIST.indexOf(this.getCurrentBreakpoint());
		const checkBreakpointIndex = BS_GRID_BREAKPOINTS_LIST.indexOf(breakpoint);

		return currentBreakpointIndex >= checkBreakpointIndex;
	}

	public static mediaBreakPointDown(breakpoint: Breakpoint): boolean {
		const currentBreakpointIndex = BS_GRID_BREAKPOINTS_LIST.indexOf(this.getCurrentBreakpoint());
		const checkBreakpointIndex = BS_GRID_BREAKPOINTS_LIST.indexOf(breakpoint);

		return currentBreakpointIndex < checkBreakpointIndex;
	}
}
